module.exports = __webpack_public_path__ + "img/axcess.fff4abce.svg";